import type { SVGProps, FC } from "react"

const SvgEquipmentSelection: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 18.301 18.377"
    fill="currentColor"
    {...props}
  >
    <g data-name="Group 140">
      <path
        data-name="Path 105"
        d="M18.204 2.409a.1.1 0 0 0-.065-.087.163.163 0 0 0-.109.022l-1.956 1.912-2.02-2.02L16.004.28a.105.105 0 0 0 0-.152c-.022-.022-.022-.022-.043-.022a4.59 4.59 0 0 0-4.106 1.13 3.019 3.019 0 0 0-.604 3.064c.022.109.043.239.065.326-.7.739-5.953 6.018-6.735 6.756a5.903 5.903 0 0 0-.282-.065 2.924 2.924 0 0 0-3.063.587 4.506 4.506 0 0 0-1.132 4.061.119.119 0 0 0 .13.087.076.076 0 0 0 .043-.022l1.955-1.912 2.02 2.02-1.948 1.956a.105.105 0 0 0 0 .152c.022.022.022.022.043.022a4.6 4.6 0 0 0 .956.109 4.49 4.49 0 0 0 3.15-1.26 3.019 3.019 0 0 0 .608-3.063c-.022-.109-.043-.239-.065-.326.7-.739 5.953-6.018 6.735-6.756l.282.065a2.911 2.911 0 0 0 3.063-.565 4.566 4.566 0 0 0 1.128-4.063Z"
      />
    </g>
  </svg>
)

export default SvgEquipmentSelection
